module.exports = __webpack_public_path__ + "img/sale.0b852829.png";